import { msg } from "../swal_msg";
import { protectedReq } from "../../helpers/requestHelper";

// resumen en panel (productos / categorías / pedidos)
export const getModuleSummary = async(setModuleData, setSnackbarData) => {
    try {
        const resp = await protectedReq('dashboard/module-summary');
        const body = await resp.json();
        if (body.status)
            setModuleData(e => ({ ...e, ...body.resp }));
        else
            setSnackbarData({
                open: true, message: 'Incidente al recuperar info'
            });
    } catch (err) {
        setSnackbarData({
            open: true, message: 'No se pudo recuperar info'
        });
    }
};

// obtener toda la información para dashboard
export const dashboardData = async() => {
    try {
        const resp = await protectedReq('dashboard/data');
        const body = await resp.json();
        return body.status ? body.resp : null;
    } catch (err) {
        msg('error', 'Ventas dashboard',
        'No se pudo recuperar la información de ventas');
        return null;
    }
};

// obtener más pedidos de base de datos
// de acuerdo con años seleccionados
export const getOrdersByYear = async(yearsToFetch) => {
    try {
        const resp = await protectedReq('dashboard/orders-by-year', { yearsToFetch }, 'POST');
        const body = await resp.json();
        return body.status ? body.resp.orders : null;
    } catch (err) {
        msg('error', `Ticket promedio`,
        `No se pudieron recuperar los pedidos del año`);
        return null;
    }
};

export const getDashboardOrdersExport = async(filters) => {
    try {
        const resp = await protectedReq(
            'dashboard/orders-export', filters, 'POST'
        );
        const body = await resp.json();

        if (resp.status === 403)
            return { status: false, msg: 'forbidden' };

        return body.status
            ? { status: true, ...body.resp }
            : { status: false, msg: body.msg || 'request-err' };
    } catch (err) {
        return { status: false, msg: 'request-err' };
    }
};

export const getHistoricalTopProducts = async() => {
    try {
        const resp = await protectedReq('dashboard/top-products-history');
        const body = await resp.json();
        return body.status ? body.resp.products : null;
    } catch (err) {
        return null;
    }
};
